var _defineProperty = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/defineProperty");
var _slicedToArray = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/slicedToArray");
var _toConsumableArray = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/toConsumableArray");
var URL = require('whatwg-url');
// https://stackoverflow.com/a/19709846/308237
var absoluteUrlRX = new RegExp('^(?:[a-z]+:)?//', 'i');
var headersToArray = function headersToArray(headers) {
  // node-fetch 1 Headers
  if (typeof headers.raw === 'function') {
    return Object.entries(headers.raw());
  } else if (headers[Symbol.iterator]) {
    return _toConsumableArray(headers);
  } else {
    return Object.entries(headers);
  }
};
var zipObject = function zipObject(entries) {
  return entries.reduce(function (obj, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];
    return Object.assign(obj, _defineProperty({}, key, val));
  }, {});
};
var normalizeUrl = function normalizeUrl(url) {
  if (typeof url === 'function' || url instanceof RegExp || /^(begin|end|glob|express|path)\:/.test(url)) {
    return url;
  }
  if (absoluteUrlRX.test(url)) {
    var u = new URL.URL(url);
    return u.href;
  } else {
    var _u = new URL.URL(url, 'http://dummy');
    return _u.pathname + _u.search;
  }
};
module.exports = {
  normalizeRequest: function normalizeRequest(url, options, Request) {
    if (Request.prototype.isPrototypeOf(url)) {
      var obj = {
        url: normalizeUrl(url.url),
        options: {
          method: url.method
        },
        request: url
      };
      var headers = headersToArray(url.headers);
      if (headers.length) {
        obj.options.headers = zipObject(headers);
      }
      return obj;
    } else if (typeof url === 'string' ||
    // horrible URL object duck-typing
    typeof url === 'object' && 'href' in url) {
      return {
        url: normalizeUrl(url),
        options: options
      };
    } else if (typeof url === 'object') {
      throw new TypeError('fetch-mock: Unrecognised Request object. Read the Config and Installation sections of the docs');
    } else {
      throw new TypeError('fetch-mock: Invalid arguments passed to fetch');
    }
  },
  normalizeUrl: normalizeUrl,
  getPath: function getPath(url) {
    var u = absoluteUrlRX.test(url) ? new URL.URL(url) : new URL.URL(url, 'http://dummy');
    return u.pathname;
  },
  getQuery: function getQuery(url) {
    var u = absoluteUrlRX.test(url) ? new URL.URL(url) : new URL.URL(url, 'http://dummy');
    return u.search ? u.search.substr(1) : '';
  },
  headers: {
    normalize: function normalize(headers) {
      return zipObject(headersToArray(headers));
    },
    toLowerCase: function toLowerCase(headers) {
      return Object.keys(headers).reduce(function (obj, k) {
        obj[k.toLowerCase()] = headers[k];
        return obj;
      }, {});
    },
    equal: function equal(actualHeader, expectedHeader) {
      actualHeader = Array.isArray(actualHeader) ? actualHeader : [actualHeader];
      expectedHeader = Array.isArray(expectedHeader) ? expectedHeader : [expectedHeader];
      if (actualHeader.length !== expectedHeader.length) {
        return false;
      }
      return actualHeader.every(function (val, i) {
        return val === expectedHeader[i];
      });
    }
  }
};